


  
  

  var faLocationDot = {
    prefix: 'fass',
    iconName: 'location-dot',
    icon: [
      384,
      512,
      ["map-marker-alt"],
      'f3c5',
      
      'M192 512s192-208 192-320C384 86 298 0 192 0S0 86 0 192C0 304 192 512 192 512zm0-384a64 64 0 1 1 0 128 64 64 0 1 1 0-128z'
      
    ]
  };

  
    var faMapMarkerAlt = faLocationDot;
  

  
  

  var faUserGear = {
    prefix: 'fass',
    iconName: 'user-gear',
    icon: [
      640,
      512,
      ["user-cog"],
      'f4fe',
      
      'M224 0a128 128 0 1 1 0 256A128 128 0 1 1 224 0zM404 484.3l0 27.7L0 512 64 304l241.4 0-15.5 26.9L326 351.7l-36.1 20.8 77 133.2L404 484.3zm32-277.9l88.1 0 0 42.4c7.9 3.4 15.4 7.7 22.3 12.8l35-20.2 45 77.8-35.2 20.3c.4 4 .7 8.1 .7 12.3s-.2 8.2-.7 12.3l35.2 20.3-45 77.8-35.1-20.2c-6.9 5.1-14.3 9.4-22.3 12.8l0 42.4L436 497l0-42.2c-8-3.4-15.6-7.7-22.5-12.9l-34.9 20.1-45-77.8 34.9-20.1c-.4-4.1-.7-8.2-.7-12.4s.2-8.3 .7-12.4l-34.9-20.2 44.9-77.8 34.9 20.2c6.9-5.1 14.5-9.4 22.5-12.9l0-42.2zm92.1 145.3a48.1 48.1 0 1 0 -96.1 0 48.1 48.1 0 1 0 96.1 0z'
      
    ]
  };

  
    var faUserCog = faUserGear;
  

  
  

  var faFileContract = {
    prefix: 'fass',
    iconName: 'file-contract',
    icon: [
      384,
      512,
      [],
      'f56c',
      
      'M224 0L0 0 0 512l384 0 0-352-160 0L224 0zm32 0l0 128 128 0L256 0zM80 64l64 0 16 0 0 32-16 0L80 96 64 96l0-32 16 0zm0 64l64 0 16 0 0 32-16 0-64 0-16 0 0-32 16 0zm56 176l16 0 11.9 0 3.4 11.4 15.4 51.4 3-5.9 4.4-8.8 9.9 0 32 0 9.9 0 4.4 8.8L257.9 384l46.1 0 16 0 0 32-16 0-56 0-9.9 0-4.4-8.8L222.1 384l-12.2 0-11.6 23.2-4.4 8.8-9.9 0-8 0-11.9 0-3.4-11.4L144 349l-16.7 55.6L123.9 416 112 416l-32 0-16 0 0-32 16 0 20.1 0 20.6-68.6 3.4-11.4 11.9 0z'
      
    ]
  };

  

  
  

  var faCircleArrowUp = {
    prefix: 'fass',
    iconName: 'circle-arrow-up',
    icon: [
      512,
      512,
      ["arrow-circle-up"],
      'f0aa',
      
      'M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm17-409L385 215l17 17L368 265.9l-17-17-71-71L280 392l0 24-48 0 0-24 0-214.1-71 71-17 17L110.1 232l17-17L239 103l17-17 17 17z'
      
    ]
  };

  
    var faArrowCircleUp = faCircleArrowUp;
  

  
  

  var faCaretDown = {
    prefix: 'fass',
    iconName: 'caret-down',
    icon: [
      320,
      512,
      [],
      'f0d7',
      
      'M320 240L160 384 0 240l0-48 320 0 0 48z'
      
    ]
  };

  

  
  

  var faPlus = {
    prefix: 'fass',
    iconName: 'plus',
    icon: [
      448,
      512,
      [10133,61543,"add"],
      '2b',
      
      'M256 80l0-32-64 0 0 32 0 144L48 224l-32 0 0 64 32 0 144 0 0 144 0 32 64 0 0-32 0-144 144 0 32 0 0-64-32 0-144 0 0-144z'
      
    ]
  };

  
    var faAdd = faPlus;
  

  
  

  var faArrowLeft = {
    prefix: 'fass',
    iconName: 'arrow-left',
    icon: [
      448,
      512,
      [8592],
      'f060',
      
      'M25.4 278.6L2.7 256l22.6-22.6 144-144L192 66.7 237.2 112l-22.6 22.6L125.2 224 416 224l32 0 0 64-32 0-290.7 0 89.4 89.4L237.2 400 192 445.3l-22.6-22.6-144-144z'
      
    ]
  };

  

  
  

  var faMessagesQuestion = {
    prefix: 'fass',
    iconName: 'messages-question',
    icon: [
      640,
      512,
      [],
      'e1e7',
      
      'M416 0L0 0 0 320l96 0 0 64 106.7-64L416 320 416 0zM256 352l0 96 181.3 0L544 512l0-64 96 0 0-320-192 0 0 224-192 0zM134.7 108c0-25.8 20.9-46.7 46.7-46.7l47.4 0c29.1 0 52.6 23.6 52.6 52.6c0 18.8-10.1 36.3-26.4 45.6L228 175l0 6.3 0 20-40 0 0-20 0-17.9 0-11.6 10-5.8L235 124.9c3.9-2.3 6.3-6.4 6.3-10.9c0-7-5.7-12.6-12.6-12.6l-47.4 0c-3.7 0-6.7 3-6.7 6.7l0 5.5-40 0 0-5.5zM188 234.7l40 0 0 40-40 0 0-40z'
      
    ]
  };

  

  
  

  var faCircleStar = {
    prefix: 'fass',
    iconName: 'circle-star',
    icon: [
      512,
      512,
      ["star-circle"],
      'e123',
      
      'M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm47-320.7l105.1 15.3-76.1 74.2 18 104.7L256 336l-94 49.4 18-104.7-76.1-74.2L209 191.3 256 96l47 95.3z'
      
    ]
  };

  
    var faStarCircle = faCircleStar;
  

  
  

  var faCaretUp = {
    prefix: 'fass',
    iconName: 'caret-up',
    icon: [
      320,
      512,
      [],
      'f0d8',
      
      'M0 272L160 128 320 272v48H0V272z'
      
    ]
  };

  

  
  

  var faFilePdf = {
    prefix: 'fass',
    iconName: 'file-pdf',
    icon: [
      512,
      512,
      [],
      'f1c1',
      
      'M0 0L224 0l0 160 160 0 0 144-272 0 0 208L0 512 0 0zM384 128l-128 0L256 0 384 128zM176 352l32 0c30.9 0 56 25.1 56 56s-25.1 56-56 56l-16 0 0 32 0 16-32 0 0-16 0-48 0-80 0-16 16 0zm32 80c13.3 0 24-10.7 24-24s-10.7-24-24-24l-16 0 0 48 16 0zm96-80l32 0c26.5 0 48 21.5 48 48l0 64c0 26.5-21.5 48-48 48l-32 0-16 0 0-16 0-128 0-16 16 0zm32 128c8.8 0 16-7.2 16-16l0-64c0-8.8-7.2-16-16-16l-16 0 0 96 16 0zm80-128l16 0 48 0 16 0 0 32-16 0-32 0 0 32 32 0 16 0 0 32-16 0-32 0 0 48 0 16-32 0 0-16 0-64 0-64 0-16z'
      
    ]
  };

  

  
  

  var faArrowRightFromBracket = {
    prefix: 'fass',
    iconName: 'arrow-right-from-bracket',
    icon: [
      512,
      512,
      ["sign-out"],
      'f08b',
      
      'M486.6 278.6L509.3 256l-22.6-22.6-128-128L336 82.7 290.7 128l22.6 22.6L386.7 224 192 224l-32 0 0 64 32 0 194.7 0-73.4 73.4L290.7 384 336 429.3l22.6-22.6 128-128zM160 96l32 0 0-64-32 0L32 32 0 32 0 64 0 448l0 32 32 0 128 0 32 0 0-64-32 0-96 0L64 96l96 0z'
      
    ]
  };

  
    var faSignOut = faArrowRightFromBracket;
  

  
  

  var faDownload = {
    prefix: 'fass',
    iconName: 'download',
    icon: [
      512,
      512,
      [],
      'f019',
      
      'M288 32l0-32L224 0l0 32 0 242.7-73.4-73.4L128 178.7 82.7 224l22.6 22.6 128 128L256 397.3l22.6-22.6 128-128L429.3 224 384 178.7l-22.6 22.6L288 274.7 288 32zM0 512l512 0 0-160-165.5 0-45.3 45.3L256 442.5l-45.3-45.3L165.5 352 0 352 0 512zM432 408a24 24 0 1 1 0 48 24 24 0 1 1 0-48z'
      
    ]
  };

  

  
  

  var faLock = {
    prefix: 'fass',
    iconName: 'lock',
    icon: [
      448,
      512,
      [128274],
      'f023',
      
      'M144 144l0 48 160 0 0-48c0-44.2-35.8-80-80-80s-80 35.8-80 80zM80 192l0-48C80 64.5 144.5 0 224 0s144 64.5 144 144l0 48 80 0 0 320L0 512 0 192l80 0z'
      
    ]
  };

  

  
  

  var faStar = {
    prefix: 'fass',
    iconName: 'star',
    icon: [
      576,
      512,
      [11088,61446],
      'f005',
      
      'M288.1 0l86.5 164 182.7 31.6L428 328.5 454.4 512 288.1 430.2 121.7 512l26.4-183.5L18.9 195.6 201.5 164 288.1 0z'
      
    ]
  };

  

  
  

  var faChevronLeft = {
    prefix: 'fass',
    iconName: 'chevron-left',
    icon: [
      320,
      512,
      [9001],
      'f053',
      
      'M2.7 256l22.6 22.6 192 192L240 493.3 285.3 448l-22.6-22.6L93.3 256 262.6 86.6 285.3 64 240 18.7 217.4 41.4l-192 192L2.7 256z'
      
    ]
  };

  

  
  

  var faCreditCard = {
    prefix: 'fass',
    iconName: 'credit-card',
    icon: [
      576,
      512,
      [62083,128179,"credit-card-alt"],
      'f09d',
      
      'M576 32L0 32l0 96 576 0 0-96zm0 192L0 224 0 480l576 0 0-256zM192 352l0 32-96 0 0-32 96 0zm32 0l160 0 0 32-160 0 0-32z'
      
    ]
  };

  
    var faCreditCardAlt = faCreditCard;
  

  
  

  var faChevronDown = {
    prefix: 'fass',
    iconName: 'chevron-down',
    icon: [
      512,
      512,
      [],
      'f078',
      
      'M256 429.3l22.6-22.6 192-192L493.3 192 448 146.7l-22.6 22.6L256 338.7 86.6 169.4 64 146.7 18.7 192l22.6 22.6 192 192L256 429.3z'
      
    ]
  };

  

  
  

  var faList = {
    prefix: 'fass',
    iconName: 'list',
    icon: [
      512,
      512,
      ["list-squares"],
      'f03a',
      
      'M112 48L16 48l0 96 96 0 0-96zm80 16l-32 0 0 64 32 0 288 0 32 0 0-64-32 0L192 64zm0 160l-32 0 0 64 32 0 288 0 32 0 0-64-32 0-288 0zm0 160l-32 0 0 64 32 0 288 0 32 0 0-64-32 0-288 0zM16 208l0 96 96 0 0-96-96 0zm96 160l-96 0 0 96 96 0 0-96z'
      
    ]
  };

  
    var faListSquares = faList;
  

  
  

  var faPen = {
    prefix: 'fass',
    iconName: 'pen',
    icon: [
      512,
      512,
      [128394],
      'f304',
      
      'M0 512L32 352 292.7 91.3l128 128L160 480 0 512zM443.3 196.7l-128-128L384 0 512 128l-68.7 68.7z'
      
    ]
  };

  

  
  

  var faLockOpen = {
    prefix: 'fass',
    iconName: 'lock-open',
    icon: [
      576,
      512,
      [],
      'f3c1',
      
      'M352 144c0-44.2 35.8-80 80-80s80 35.8 80 80l0 48 0 32 64 0 0-32 0-48C576 64.5 511.5 0 432 0S288 64.5 288 144l0 48L0 192 0 512l448 0 0-320-96 0 0-48z'
      
    ]
  };

  

  
  

  var faArrowRight = {
    prefix: 'fass',
    iconName: 'arrow-right',
    icon: [
      448,
      512,
      [8594],
      'f061',
      
      'M422.6 278.6L445.3 256l-22.6-22.6-144-144L256 66.7 210.8 112l22.6 22.6L322.8 224 32 224 0 224l0 64 32 0 290.7 0-89.4 89.4L210.8 400 256 445.3l22.6-22.6 144-144z'
      
    ]
  };

  

  
  

  var faBookmark = {
    prefix: 'fass',
    iconName: 'bookmark',
    icon: [
      384,
      512,
      [61591,128278],
      'f02e',
      
      'M0 512L192 400 384 512V0H0V512z'
      
    ]
  };

  

  
  

  var faCalendar = {
    prefix: 'fass',
    iconName: 'calendar',
    icon: [
      448,
      512,
      [128197,128198],
      'f133',
      
      'M96 0l0 64L0 64l0 96 448 0 0-96-96 0 0-64L288 0l0 64L160 64l0-64L96 0zM448 192L0 192 0 512l448 0 0-320z'
      
    ]
  };

  

  
  

  var faGear = {
    prefix: 'fass',
    iconName: 'gear',
    icon: [
      512,
      512,
      [9881,"cog"],
      'f013',
      
      'M200 0L312 0l17.2 78.4c15.8 6.5 30.6 15.1 44 25.4l76.5-24.4 56 97-59.4 54.1c1.1 8.3 1.7 16.8 1.7 25.4s-.6 17.1-1.7 25.4l59.4 54.1-56 97-76.5-24.4c-13.4 10.3-28.2 18.9-44 25.4L312 512l-112 0-17.2-78.4c-15.8-6.5-30.6-15.1-44-25.4L62.3 432.5l-56-97 59.4-54.1C64.6 273.1 64 264.6 64 256s.6-17.1 1.7-25.4L6.3 176.5l56-97 76.5 24.4c13.4-10.3 28.2-18.9 44-25.4L200 0zm56 336a80 80 0 1 0 0-160 80 80 0 1 0 0 160z'
      
    ]
  };

  
    var faCog = faGear;
  

  
  

  var faCircleArrowDown = {
    prefix: 'fass',
    iconName: 'circle-arrow-down',
    icon: [
      512,
      512,
      ["arrow-circle-down"],
      'f0ab',
      
      'M256 512A256 256 0 1 1 256 0a256 256 0 1 1 0 512zm17-103L385 297l17-17L368 246.1l-17 17-71 71L280 120l0-24-48 0 0 24 0 214.1-71-71-17-17L110.1 280l17 17L239 409l17 17 17-17z'
      
    ]
  };

  
    var faArrowCircleDown = faCircleArrowDown;
  

  
  

  var faBadge = {
    prefix: 'fass',
    iconName: 'badge',
    icon: [
      512,
      512,
      [],
      'f335',
      
      'M340.9 51.1C324.8 20.7 292.8 0 256 0s-68.8 20.7-84.9 51.1C138.2 41 101 49 75 75s-34 63.3-23.9 96.1C20.7 187.2 0 219.2 0 256s20.7 68.8 51.1 84.9C41 373.8 49 411 75 437s63.3 34 96.1 23.9C187.2 491.3 219.2 512 256 512s68.8-20.7 84.9-51.1C373.8 471 411 463 437 437s34-63.3 23.9-96.1C491.3 324.8 512 292.8 512 256s-20.7-68.8-51.1-84.9C471 138.2 463 101 437 75s-63.3-34-96.1-23.9z'
      
    ]
  };

  

  
  

  var faBuilding = {
    prefix: 'fass',
    iconName: 'building',
    icon: [
      384,
      512,
      [61687,127970],
      'f1ad',
      
      'M384 0L0 0 0 512l144 0 0-128 96 0 0 128 144 0L384 0zM64 224l64 0 0 64-64 0 0-64zm160 0l0 64-64 0 0-64 64 0zm32 0l64 0 0 64-64 0 0-64zM128 96l0 64-64 0 0-64 64 0zm32 0l64 0 0 64-64 0 0-64zm160 0l0 64-64 0 0-64 64 0z'
      
    ]
  };

  

  
  

  var faUserPlus = {
    prefix: 'fass',
    iconName: 'user-plus',
    icon: [
      640,
      512,
      [],
      'f234',
      
      'M96 128a128 128 0 1 1 256 0A128 128 0 1 1 96 128zM384 304l64 208L0 512 64 304l320 0zm120 32l0-24 0-64-64 0-24 0 0-48 24 0 64 0 0-64 0-24 48 0 0 24 0 64 64 0 24 0 0 48-24 0-64 0 0 64 0 24-48 0z'
      
    ]
  };

  

  
  

  var faShieldCheck = {
    prefix: 'fass',
    iconName: 'shield-check',
    icon: [
      512,
      512,
      [],
      'f2f7',
      
      'M256 5.7l11.5 4.4L475 90.2l19.2 7.4 1.2 20.6c2.9 49.7-4.9 125.6-37.3 199.8C425.4 392.8 367 467.1 268.6 509.4L256 514.8l-12.6-5.4C145 467.1 86.6 392.8 53.9 318C21.4 243.7 13.6 167.8 16.6 118.1l1.2-20.6L37 90.2l207.5-80L256 5.7zM369 209l17-17L352 158.1l-17 17-111 111-47-47-17-17L126.1 256l17 17 64 64 17 17 17-17L369 209z'
      
    ]
  };

  

  
  

  var faChevronRight = {
    prefix: 'fass',
    iconName: 'chevron-right',
    icon: [
      320,
      512,
      [9002],
      'f054',
      
      'M317.3 256l-22.6 22.6-192 192L80 493.3 34.7 448l22.6-22.6L226.7 256 57.4 86.6 34.7 64 80 18.7l22.6 22.6 192 192L317.3 256z'
      
    ]
  };

  

  
  

  var faRightToBracket = {
    prefix: 'fass',
    iconName: 'right-to-bracket',
    icon: [
      512,
      512,
      ["sign-in-alt"],
      'f2f6',
      
      'M192 96L352 256 192 416l-32 0 0-96L0 320 0 192l160 0 0-96 32 0zM352 416l96 0 0-320-96 0-32 0 0-64 32 0 128 0 32 0 0 32 0 384 0 32-32 0-128 0-32 0 0-64 32 0z'
      
    ]
  };

  
    var faSignInAlt = faRightToBracket;
  

  
  

  var faChevronUp = {
    prefix: 'fass',
    iconName: 'chevron-up',
    icon: [
      512,
      512,
      [],
      'f077',
      
      'M256 82.7l22.6 22.6 192 192L493.3 320 448 365.3l-22.6-22.6L256 173.3 86.6 342.6 64 365.3 18.7 320l22.6-22.6 192-192L256 82.7z'
      
    ]
  };

  

  
  

  var faTrash = {
    prefix: 'fass',
    iconName: 'trash',
    icon: [
      448,
      512,
      [],
      'f1f8',
      
      'M144 0L128 32 0 32 0 96l448 0 0-64L320 32 304 0 144 0zM416 128L32 128 56 512l336 0 24-384z'
      
    ]
  };

  

  
  

  var faCircleCaretUp = {
    prefix: 'fass',
    iconName: 'circle-caret-up',
    icon: [
      512,
      512,
      ["caret-circle-up"],
      'f331',
      
      'M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM128 272L256 144 384 272l0 32-256 0 0-32z'
      
    ]
  };

  
    var faCaretCircleUp = faCircleCaretUp;
  

  
  

  var faMagnifyingGlass = {
    prefix: 'fass',
    iconName: 'magnifying-glass',
    icon: [
      512,
      512,
      [128269,"search"],
      'f002',
      
      'M416 208c0 45.9-14.9 88.3-40 122.7L486.6 441.4 509.3 464 464 509.3l-22.6-22.6L330.7 376c-34.4 25.2-76.8 40-122.7 40C93.1 416 0 322.9 0 208S93.1 0 208 0S416 93.1 416 208zM208 352a144 144 0 1 0 0-288 144 144 0 1 0 0 288z'
      
    ]
  };

  
    var faSearch = faMagnifyingGlass;
  

  
  

  var faCircleCaretDown = {
    prefix: 'fass',
    iconName: 'circle-caret-down',
    icon: [
      512,
      512,
      ["caret-circle-down"],
      'f32d',
      
      'M256 0a256 256 0 1 0 0 512A256 256 0 1 0 256 0zM384 240L256 368 128 240l0-32 256 0 0 32z'
      
    ]
  };

  
    var faCaretCircleDown = faCircleCaretDown;
  

  
  

  var faMinus = {
    prefix: 'fass',
    iconName: 'minus',
    icon: [
      448,
      512,
      [8211,8722,10134,"subtract"],
      'f068',
      
      'M432 288l-32 0L48 288l-32 0 0-64 32 0 352 0 32 0 0 64z'
      
    ]
  };

  
    var faSubtract = faMinus;
  



export {

  faLocationDot,
  
  faMapMarkerAlt,
  

  faUserGear,
  
  faUserCog,
  

  faFileContract,
  

  faCircleArrowUp,
  
  faArrowCircleUp,
  

  faCaretDown,
  

  faPlus,
  
  faAdd,
  

  faArrowLeft,
  

  faMessagesQuestion,
  

  faCircleStar,
  
  faStarCircle,
  

  faCaretUp,
  

  faFilePdf,
  

  faArrowRightFromBracket,
  
  faSignOut,
  

  faDownload,
  

  faLock,
  

  faStar,
  

  faChevronLeft,
  

  faCreditCard,
  
  faCreditCardAlt,
  

  faChevronDown,
  

  faList,
  
  faListSquares,
  

  faPen,
  

  faLockOpen,
  

  faArrowRight,
  

  faBookmark,
  

  faCalendar,
  

  faGear,
  
  faCog,
  

  faCircleArrowDown,
  
  faArrowCircleDown,
  

  faBadge,
  

  faBuilding,
  

  faUserPlus,
  

  faShieldCheck,
  

  faChevronRight,
  

  faRightToBracket,
  
  faSignInAlt,
  

  faChevronUp,
  

  faTrash,
  

  faCircleCaretUp,
  
  faCaretCircleUp,
  

  faMagnifyingGlass,
  
  faSearch,
  

  faCircleCaretDown,
  
  faCaretCircleDown,
  

  faMinus,
  
  faSubtract,
  

};
